const _ = "first_name", E = "last_name", n = "email", o = "country", t = "phone_country", c = "country_code", s = "phone_number", I = "address", D = "postal_code", e = "city", L = "region", F = "request", N = "consent_communicate_by_phone";
export {
  I as ADDRESS_FIELD,
  e as CITY_FIELD,
  N as CONSENT_COMMUNICATE_BY_PHONE_FIELD,
  c as COUNTRY_CODE_FIELD,
  o as COUNTRY_FIELD,
  n as EMAIL_FIELD,
  _ as FIRST_NAME_FIELD,
  E as LAST_NAME_FIELD,
  t as PHONE_COUNTRY_FIELD,
  s as PHONE_NUMBER_FIELD,
  D as POSTAL_CODE_FIELD,
  L as REGION_FIELD,
  F as REQUEST_FIELD
};
